// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper--__kpR","textWrapper":"textWrapper--UrP3l","cta":"cta--B9lRh"};